import { useSelector } from 'react-redux';

import type { ReduxApplicationState } from 'src/redux/types';
import type { DeliveryFAQsProps } from './DeliveryFAQs';

export const useDeliveryFAQs = (): DeliveryFAQsProps | null => {
  const deliveryFAQs = useSelector((state: ReduxApplicationState) => state.content.deliveryFAQs);

  if (!deliveryFAQs || deliveryFAQs.items.length === 0) {
    return null;
  }

  return deliveryFAQs;
};
